import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ColumnConfig, DataTableConfig, ActionButton, ActionButtons } from '../../../infrastructure/model/interfaces/dataTable.interface';
import { Observable } from 'rxjs/Observable';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import 'rxjs/add/operator/share';

@Component({
  selector: 'sx-data-table',
  templateUrl: 'dataTable.component.html'
})
export class DataTableComponent implements OnInit {

  actions: ActionButtons[];
  @Input() actionMap: (any) => ActionButtons;

  /**
   * Los items que van a llenar la tabla
   */
  _items: Observable<any>;
  @Input()
  set items(value: Observable<any>) {
    if (value) {
      this._items = value.share();
      if (this.actionMap) {
        value.subscribe(rows => this.actions = rows.items.map(this.actionMap));
      }
    }
  }

  get items(): Observable<any> {
    return this._items;
  }

  /**
   * Los items que van a llenar la tabla
   */
  _dataTableConfig: DataTableConfig;
  @Input()
  set dataTableConfig(value: DataTableConfig) {
    this._dataTableConfig = value;
  }

  get dataTableConfig(): DataTableConfig {
    return this._dataTableConfig;
  }

  // Configuraciones de la Tabla
  // @Input('dataTableConfig') dataTableConfig: DataTableConfig;

  // Maxima cantidad de paginas que se muestran en el paginador
  @Input('maxSize') maxSize: any = 5;

  // Set to false to hide filters
  @Input('filter') filter = true;

  /**
   * Evento que indica que alguna configuracion cambio,
   * entonces deben pedir los datos con esta nueva configuracion
   */
  @Output('fetchData') fetchData: EventEmitter<any> = new EventEmitter<any>();
  // @Output('descargar') descargar: EventEmitter<any> = new EventEmitter<any>();
  @Output('actionEmitter') actionEmitter: EventEmitter<any> = new EventEmitter<any>();
  search;
  page;
  pageSize;
  sortField;
  sortDirection;
  idTransaccion;
  codSistema;
  codNegocio;
  codProducto;

  constructor() { }

  ngOnInit() {
    this.page = this._dataTableConfig.page;
    this.pageSize = this._dataTableConfig.pageSize;
    this.sortField = this._dataTableConfig.sortField;
    this.sortDirection = this._dataTableConfig.sortDirection;
    this.idTransaccion = this._dataTableConfig.idTransaccion;
    this.codSistema = this._dataTableConfig.codSistema;
  }

  cambioDePagina(page) {
    // Cambio de pagina, mandamos a pedir los datos con
    // los valores actualizados
    this.page = page;

    this.buildAndEmit();
  }

  /**
   * Funcion que se llama cuando el ordenamiento cambio
   *
   * @param sortField id de la columna por la cual se va a ordenar
   */
  changeSort(sortField) {
    let sortDirection = 'desc';
    if (this.sortField === sortField) {
      sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    }

    this.sortField = sortField;
    this.sortDirection = sortDirection;

    this.buildAndEmit();
  }

  aplicarBusqueda() {
    this.buildAndEmit();
  }

  buildAndEmit() {
    const query = {
      pageSize: this.pageSize,
      page: this.page,
      sortField: this.sortField,
      sortDirection: this.sortDirection,
      search: null,
      idTransaccion: this.idTransaccion,
      codSistema: this.codSistema,
      codNegocio: this.codNegocio,
      codProducto: this.codProducto,
    };

    if (this.search) {
      query.search = this.search;
    }

    this.fetchData.emit(query);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/dataTable/dataTable.component.ts